import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAssetsApi } from '../../../store/api/hooks/assetsApiHook';
import toast from 'react-hot-toast';
import { AgGridReact } from 'ag-grid-react';
import { showLocalDate } from '../../../_common/functions';
import Drawer from '../../../components/Drawer';
import Button from '../../../components/elements/button';
import CreatePart from './createPart';
import Icon from '../../../components/icons';
import { useDialog } from '../../../store/api/hooks/dialogHook';

interface Part {
    id: number;
    name: string;
    quantity: number;
}

interface PartsListProps {
    parts?: Part[];
}

const PartsList: React.FC<PartsListProps> = ({ parts = [] }) => {
    const params: any = useParams();
    const assetsAPI = useAssetsApi();
    const [assetDetails, setAssetDetails] = useState<any>(null)
    const [columnDefs, setColumnDefs] = useState<any[] | null>(null);
    const [gridApi, setGridApi] = useState<any>(null);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const addWarrentyDrawerRef: any = React.createRef<HTMLButtonElement>();
    const addNewWarrentyRef: any = useRef();
    const [partDetails, setPartDetails] = useState<any>(null)
    const { confirm } = useDialog();

    const handleActionChange = (e: any, params2: any) => {
        const action = e.target.value;
        const rowData = params2.data;
        console.log("rowData===", rowData)

        switch (action) {
            case "edit":
                // Implement edit action

                break;
            case "delete":
                // Implement delete action
                confirm({
                    type: 'delete',
                    title: 'Delete Part List',
                    message: 'Are you sure you want to delete this Part List?',
                    onConfirm: () => {
                        assetsAPI.DeleteAssetDetails({ assetDetailsID: rowData.assetDetailsID }, (data: any, msg: any) => {
                            toast.success(msg);
                            GetAssetDetailsList(params.id);
                        }, (error: any) => {
                            toast.error(error);
                        });
                    }
                });
                break;
            case "duplicate":
                console.log("Duplicate action for row: ", rowData);
                break;
            case "move-asset":
                // Implement move asset action
                console.log("Move Asset action for row: ", rowData);
                break;

            default:
                console.log("Unknown action: ", action);
                break;
        }
        e.target.selectedIndex = -1;
    };
    const GetAssetDetailsList = (assetID: any) => {

        const payload = { assetID: assetID };

        assetsAPI.GetAssetDetailsList(payload, (resp: any) => {
            console.log("resp", resp)
            setAssetDetails(resp.assetDetailsList ? resp.assetDetailsList : []);
        },
            (error: any) => {
                console.log("error =>", error);
                // toast.error(error);
            }
        );
    }
    useEffect(() => {
        if (params.id) {
            GetAssetDetailsList(params.id);



        }
    }, [params]);

    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
        }
    };

    useEffect(() => {
        setColumnDefs([


            {
                headerName: "Part Code",
                width: 220,
                field: "partsCode",
                headerClass: "bg-[#f0f0f0]",
                cellRenderer: (data: any) => {
                    return (
                        <p className="hover:text-primary font-semibold ">
                            {data?.data?.partsCode
                                ? data?.data?.partsCode
                                : "-"}
                        </p>
                    );
                },
            },
            {
                headerName: "Part name",
                field: "partsName",
                headerClass: "bg-[#f0f0f0] ",
                minWidth: 250,
                flex: 1,
                cellRenderer: (data: any) => {
                    return (
                        <p title={`${data?.data?.partsName
                            ? data?.data?.partsName
                            : "-"}`} className="hover:text-primary font-semibold   text-ellipsis overflow-hidden">
                            {data?.data?.partsName
                                ? data?.data?.partsName
                                : "-"}
                        </p>
                    );
                },
            },

            {
                headerName: "Quantity",
                width: 170,
                field: "quantity",
                headerClass: "bg-[#f0f0f0]",
                cellRenderer: (data: any) => {
                    return (
                        <p className="hover:text-primary font-semibold ">
                            {data?.data?.quantity
                                ? data?.data?.quantity
                                : "-"}
                        </p>
                    );
                },
            },

            {
                headerName: "Added by",
                width: 200,
                field: "addedByName",
                headerClass: "bg-[#f0f0f0]",
                cellRenderer: (data: any) => {
                    const daysUntilExpiry = data?.data?.addedByName;

                    let displayText;
                    if (daysUntilExpiry) {
                        displayText = daysUntilExpiry

                    } else {
                        displayText = "-";
                    }
                    return (
                        <p className="hover:text-primary font-semibold  ">

                            {displayText}
                        </p>
                    );
                },
            },

            {
                headerName: "Added date",
                width: 170,
                field: "addedDate",
                headerClass: "bg-[#f0f0f0]",
                cellRenderer: (data: any) => {
                    return (
                        <p className="hover:text-primary font-semibold ">
                            {data?.data?.addedDate
                                ? showLocalDate(data?.data?.addedDate)
                                : "-"}
                        </p>
                    );
                },
            },


            {
                headerName: "Actions",
                field: "actions",
                headerClass: 'bg-[#f0f0f0] text-center',
                width: 90,

                cellRenderer: (params: any) => {
                    return (
                        <div className='relative h-full w-full flex items-center justify-center'>
                            <Icon name='threedote' size={1.25} className='text-[#000000]' onClick={(e: any) => {
                                e.stopPropagation();
                                e.preventDefault();
                                const dropdown: any = document.querySelector('.action-dropdown');
                                if (dropdown) {
                                    dropdown.focus();
                                }
                                return false;
                            }} />
                            <select
                                onChange={(e) => {

                                    handleActionChange(e, params);
                                    //e.target.value = '';
                                }}
                                onFocus={(e) => {
                                    e.target.selectedIndex = -1;
                                }
                                }
                                className="action-dropdown"
                                value={''}
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    opacity: 0,
                                    cursor: "pointer",
                                }}
                            >

                                <option value="delete">Delete</option>

                            </select>
                        </div>
                    );
                },

            }




        ]);
    }, [params]);

    return (
        <div>

            <div className='flex items-center justify-between pl-5 pr-3 h-[3.75rem]'>
                <div className='flex items-center gap-2'>
                    <h1 className='text-[0.9rem] leading-[1]'>Part List</h1>

                </div>
                <div className='flex items-center gap-2'>

                    <Drawer _ref={addWarrentyDrawerRef} onClose={() => {
                        setPartDetails(null);
                        GetAssetDetailsList(params.id);
                        addNewWarrentyRef?.current?.reset()

                    }} outsideClose={false}>
                        <Drawer.Button>
                            <Button >Add Part</Button>
                        </Drawer.Button>
                        <Drawer.Content title={partDetails ? 'Edit part' : 'Add Part'} className='!w-[39.563rem]'>
                            <CreatePart _ref={addNewWarrentyRef} editData={partDetails} onCreate={() => {
                                GetAssetDetailsList(params.id);
                                addNewWarrentyRef?.current?.reset()
                                setPartDetails(null)
                                addWarrentyDrawerRef.current.close();

                            }} onCancel={() => {
                                GetAssetDetailsList(params.id);
                                setPartDetails(null)
                                addNewWarrentyRef?.current?.reset()
                                addWarrentyDrawerRef.current.close();

                            }} />
                        </Drawer.Content>
                    </Drawer>
                </div>

            </div>
            <AgGridReact
                columnDefs={columnDefs} // Pass columnDefs
                rowData={assetDetails || []} // Pass rowData
                pagination={false}
                rowSelection="multiple"
                onGridReady={onGridReady}
                domLayout="autoHeight"
                onRowClicked={onRowClicked}
                noRowsOverlayComponent={() => (
                    <div className="flex items-center justify-center h-full">
                        <div className="text-center text-gray-500">
                            <div className="text-lg font-medium">No Data Found</div>
                        </div>
                    </div>
                )}
            />
        </div>
    );
};

export default PartsList;